import instance from "./instance";
import { ENV } from "@/constants/env";
import { ResponseDataDto } from "@/dto/ResponseDto";
import {
  AdminBoardItemDto,
  AdminBoardListResponseDto,
  AdminBoardCreateRequestDto,
  AdminBoardUpdateRequestDto,
} from "@/dto/AdminBoardDto";

// 게시판 관리 API 경로
const PREFIX_PATH = "admin/board";

/**
 * 게시판 목록 조회
 * @param comId 회사 ID
 * @param page 페이지 번호
 * @param limit 페이지당 항목 수
 * @returns 게시판 목록 페이지네이션 응답
 */
export const findAll = async (
  comId: string,
  page?: number,
  limit?: number
): Promise<ResponseDataDto<AdminBoardListResponseDto>> => {
  // 캐시 방지를 위한 타임스탬프 추가
  const timestamp = new Date().getTime();
  let query = `?comId=${comId}&_t=${timestamp}`;

  if (page) query += `&page=${page}`;
  if (limit) query += `&limit=${limit}`;

  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}${query}`);
};

/**
 * 게시판 항목 상세 조회
 * @param boardId 게시판 ID
 * @returns 게시판 항목 상세 정보
 */
export const findById = async (
  boardId: string
): Promise<ResponseDataDto<AdminBoardItemDto>> => {
  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}/${boardId}`);
};

/**
 * 게시판 항목 생성
 * @param request 게시판 생성 요청 DTO
 * @returns 생성된 게시판 항목 정보
 */
export const create = async (
  request: AdminBoardCreateRequestDto
): Promise<ResponseDataDto<AdminBoardItemDto>> => {
  return await instance.post(`${ENV.PRE_FIX}/${PREFIX_PATH}`, request);
};

/**
 * 게시판 항목 수정
 * @param request 게시판 수정 요청 DTO
 * @returns 수정된 게시판 항목 정보
 */
export const update = async (
  request: AdminBoardUpdateRequestDto
): Promise<ResponseDataDto<AdminBoardItemDto>> => {
  return await instance.put(`${ENV.PRE_FIX}/${PREFIX_PATH}`, request);
};

/**
 * 게시판 항목 삭제
 * @param boardId 게시판 ID
 * @returns 삭제된 게시판 항목 정보
 */
export const deleteById = async (
  boardId: string
): Promise<ResponseDataDto<AdminBoardItemDto>> => {
  return await instance.delete(`${ENV.PRE_FIX}/${PREFIX_PATH}`, {
    data: { boardId: Number(boardId) },
  });
};

/**
 * 신규 자료 요청 
 * @param comId 회사 ID
 * @returns 게시판 페이지 목록 응답
 */

